import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "points-vertical",
  "use": "points-vertical-usage",
  "viewBox": "0 0 40 160",
  "content": "<symbol viewBox=\"0 0 40 160\" id=\"points-vertical\"><path d=\"M40 80c0 11.046-8.954 20-20 20S0 91.046 0 80s8.954-20 20-20 20 8.954 20 20zm-20 40c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20zM20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/points-vertical.svg
// module id = 183
// module chunks = 0